export function scannerNumber(value: number, digits = 4): string {
  return value.toLocaleString(undefined, { maximumFractionDigits: digits });
}
export function scannerUsd(value: number): string {
  return value.toLocaleString(undefined, { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: value < 1 ? 4 : 2 });
}
export function materialUnits(baseUnits: string): number { return Number(BigInt(baseUnits)) / 1e6; }
export function scannerTitle(value: string): string { return value.toLowerCase().replaceAll("_", " ").replace(/\b\w/g, letter => letter.toUpperCase()); }
